import { useEffect, useRef, useState } from "react";
import useApi from "../../../../Utils/BackendClient";
import { useIsMobile } from "../../../../Utils/ResizeUtils";

import ProductStatusCircle from "../../../UIElements/ProductStatusCircle";

import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { confirmPopup, ConfirmPopup } from "primereact/confirmpopup";
import { DataTable } from "primereact/datatable";
import { Toast } from "primereact/toast";
import { Toolbar } from "primereact/toolbar";

import commonStyle from "../../CommonStyles.module.css";

const DocumentTemplates = () => {

    const isMobile = useIsMobile();
    const toast = useRef();

    const { fetchDocumentTemplates } = useApi();

    const [loading, setLoading] = useState(true);
    const [templates, setTemplates] = useState(null);
    const [totalRecords, setTotalRecords] = useState(0);
    const [lazyState, setlazyState] = useState({
        first: 0,
        rows: 10,
        page: 1,
        sortField: null,
        sortOrder: null,
    });

    useEffect(() => {

        const fetchData = async () => {

            const response = await fetchDocumentTemplates(lazyState);

            if (response.status !== 200){
                toast.current.show({ severity: "error", summary: "Помилка завантаження списку", detail: "Помилка сервера " + response.status, life: 3000 });
            }
            else{
                setTotalRecords(response.data.count);
                setTemplates(response.data.results);
            }
            
            setLoading(false);
        }

        fetchData();

    }, [fetchDocumentTemplates, lazyState]);

    const confirmDelete = (event, rowData) => {
        confirmPopup({
            group: 'headless',
            target: event.currentTarget,
            message: 'Підтвердіть видалення темплейту',
            icon: 'pi pi-exclamation-triangle',
            defaultFocus: 'accept',
            acceptLabel: "Так",
            rejectLabel: "Hi",
            accept: () => { console.log(rowData) }
        });
    }

    const onPage = (event) => {
        event.page = event.page +1;
        setlazyState(event);
    };

    const toolbarRightTemplate = () => {
        return (<div className="flex flex-wrap gap-2">
            <Button label="Додати шаблон" severity="success" className={commonStyle.addButton} onClick={console.log("Click!")} />
        </div>)
    }

    const actionBodyTemplate = rowData => {
        return (<div className="flex flex-wrap gap-2">
            <Button
                icon="pi pi-trash"
                className={`p-button-rounded p-button-danger ${commonStyle.deleteButton}`}
                tooltip={"Видалити"}
                tooltipOptions={{ showOnDisabled: true }}
                onClick={(event) => confirmDelete(event, rowData)}
            />
            <Button
                icon="pi pi-pencil"
                className={`p-button-rounded p-button-info ${commonStyle.editButton}`}
                onClick={() => console.log(rowData)}
            />
        </div>
        );
    };

    const mobileRowBody = rowData => {
        const PDFColor = rowData.use_for_pdf_generate ? "#03C04A" : "#EF4444";  
        const ThermalPrinterColor = rowData.use_for_termal_print ? "#03C04A" : "#EF4444";

        return (
            <div className="flex justify-content-between flex-wrap">
                <div className="grid w-8">
                    <div className="col-2 flex justify-content-center align-items-center">
                        <ProductStatusCircle id={rowData.id} type="statusCircle" isActive={rowData.status === "ACTIVE"}/>
                    </div>
                    <div className="col-10">
                        <div className="flex-column">
                            <div className="font-bold"> {rowData.name}</div>
                            <div>{rowData.platform_name}</div>
                            <div style={{ color: PDFColor }}><i className={`pi ${rowData.use_for_pdf_generate ? "pi-check" : "pi-times"}`}/>PDF</div>
                            <div style={{ color: ThermalPrinterColor }}><i className={`pi ${rowData.use_for_termal_print ? "pi-check" : "pi-times"}`}/>Термопринтер</div>
                        </div>
                    </div>
                </div>
                <div className="flex justify-content-center align-items-center">
                    {actionBodyTemplate(rowData)}
                </div>
            </div>
        )
    }
    
    return (<>
        <Toast ref={toast} />   
        <Toolbar className="mb-4" end={toolbarRightTemplate} />
        <div className='grid'>
            <div className='col-12 justify-content-center'>
                {!isMobile && <DataTable value={templates} stripedRows lazy rows={lazyState.rows} paginator onPage={onPage} first={lazyState.first} loading={loading} totalRecords={totalRecords} rowsPerPageOptions={[10, 20, 50]} >
                    <Column field="name" header="Назва шаблону" sortable />
                    <Column field="platform_name" header="Сутність"/>
                    <Column field="use_for_pdf_generate" header="PDF" body={rowData => <i className={`pi ${rowData.use_for_pdf_generate ? "pi-check" : "pi-times"}`}/>} />
                    <Column field="use_for_termal_print" header="Термопринтер" body={rowData => <i className={`pi ${rowData.use_for_termal_print ? "pi-check" : "pi-times"}`}/>}/>
                    <Column field="status" header="Cтатус" body={rowData => <ProductStatusCircle id={rowData.id} type="statusCircle" isActive={rowData.status === "ACTIVE"}/>}/>
                    <Column field="action" body={actionBodyTemplate} />
                </DataTable>}
                {isMobile && <DataTable value={templates} stripedRows lazy rows={lazyState.rows} paginator onPage={onPage} first={lazyState.first} loading={loading} totalRecords={totalRecords} rowsPerPageOptions={[10, 20, 50]} 
                    paginatorTemplate="FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink RowsPerPageDropdown" dataKey="id" emptyMessage="Клієнтів не знайдено" >
                    <Column field="id" headerStyle={{ display: 'none' }} body={mobileRowBody} />
                </DataTable>}
            </div>
            <ConfirmPopup group="headless" />
        </div>
    </>)
}

export default DocumentTemplates;